import { createContext } from "react"
import { HistoricoVersoesInicial, HistoricoVersoesModel } from "../models/historicoVersoesModel"
import { HistoricoVersoesActionModel } from "./historicoVersoesActions"

type HistoricoVersoesContextProps = {
    historico: HistoricoVersoesModel
    dispatch: React.Dispatch<HistoricoVersoesActionModel>
    erroCarregamento: string | null
}

const initialContextValue: HistoricoVersoesContextProps = {
    historico: HistoricoVersoesInicial,
    dispatch: () => {},
    erroCarregamento: null,
}

export const HistoricoVersoesContext = createContext<HistoricoVersoesContextProps>(initialContextValue)
